class UiIcon extends HTMLElement {
  static observedAttributes: ["name", "width", "height"];

  async connectedCallback() {
    const iconName = this.getAttribute("name");
    const width = this.getAttribute("width") || "16";
    const height = this.getAttribute("height") || "16";

    this.innerHTML = /*html*/ `<svg class="icon ${iconName}" width="${width}" height="${height}"><use href="#${iconName}"></use></svg>`;
  }
}

customElements.define("ui-icon", UiIcon);
